import { render, staticRenderFns } from "./OperaShopDetailWindow.vue?vue&type=template&id=6f096ac1&scoped=true&"
import script from "./OperaShopDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopDetailWindow.vue?vue&type=style&index=0&id=6f096ac1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f096ac1",
  null
  
)

export default component.exports